import { connect } from 'react-redux';
import Notifications from "../components/Notifications"
import { getNotificationList, removeNotification, readNotificationList } from "../modules/notification"


const mapDispatchToProps = {
  getNotificationList,
  removeNotification,
  readNotificationList
};

const mapStateToProps = state => ({
  perms: state.auth.perms,
  notification: state.notification
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);


// WEBPACK FOOTER //
// src/routes/notification/containers/NotificationContainer.js